module.exports = __webpack_public_path__ + "images/spartace281b042e822169d2846ea3eb541ef2.png";